import vu from 'assets/portfolio/image/vu.jpg'
import tuan from 'assets/portfolio/image/tuan.jpg'
import nam from 'assets/portfolio/image/nam.jpg'

const FeedBackData = [
  {
    name: 'Chau Hoai Vu',
    img: vu,
    content:
      "I'm immensely grateful for my internship at Simpson Strong-tie. Working under a front-end team in an exceptional environment, I gained invaluable knowledge and skills, and I'm excited about future collaborations."
  },
  {
    name: 'Tran Trieu Tuan',
    img: tuan,
    content:
      'Interning at Simpson Strong-Tie transformed me. Exceptional guidance from the front-end team, a supportive environment, and passion-aligned opportunities fueled my professional and personal growth. Grateful for this journey.'
  },
  {
    name: 'Nguyen Duc Nam',
    img: nam,
    content:
      "During my frontend internship, I've significantly strengthened my coding and problem-solving skills while appreciating the supportive team and mentors, and I'm committed to further enhancing my abilities."
  }
]

export default FeedBackData
